export const allInOneData = {
  banner: {
    tag: '软硬一体 · 私有化部署 · 内网离线',
    title: '智能翻译硬件：智译一体机',
    desc: '一款软硬件一体的智能翻译小型工作站，支持 3-5 人团队使用。客户可选择指定语言模型部署到一体机中，内网离线使用。广泛应用于数据安全要求极高、翻译语言固定、性能要求不高且预算有限的小微企业或个人。',
  },
  // 产品功能介绍
  introduce: {
    title: '小型团队 AI 离线翻译低预算理想之选',
    items: [
      { icon: '/images/all-in-one/introduce-1.png', name: '文本翻译', desc: '每次最多 5000 字，支持原译对照' },
      { icon: '/images/all-in-one/introduce-2.png', name: '文档翻译', desc: '支持 word、ppt、excel、txt、html 等类型翻译' },
      { icon: '/images/all-in-one/introduce-3.png', name: '记忆术语管理', desc: '翻译术语和记忆实时调优机翻结果' },
      { icon: '/images/all-in-one/introduce-4.png', name: '翻译统计', desc: '使用成员翻译字数统计，掌握使用情况' },
    ],
  },
  // 产品优势
  advantages: {
    title: '产品优势',
    image: '/images/all-in-one/advantage.png',
    icon: '/images/all-in-one/advantage-icon.png',
    items: [
      '主流语言全覆盖，垂直领域翻译专业',
      '翻译数据安全，便携方便',
      '相比传统服务器的私有化部署，价格更实惠',
      '软硬件适配经过多重调优测试，算力与性能匹配最佳',
    ],
  },
  // 软硬件配置
  config: {
    title: '软硬件高性价比配置',
    photos: [
      { src: '/images/all-in-one/config-1.png', alt: '智译一体机外观' },
      { src: '/images/all-in-one/config-2.png', alt: '智译一体机机身' },
    ],
    specs: [
      { title: '标准翻译一体机 硬件配置', src: '/images/all-in-one/config-3.png' },
      { title: '国产化版翻译一体机 硬件配置', src: '/images/all-in-one/config-4.png' },
    ],
  },
  related: [
    { title: 'MossTeams 智能会议双屏机', desc: '会议室专属 AI 同传秘书', href: '/mossteams/dual-screen', image: '/images/recommendation/mossteams-dual-screen.jpg' },
    { title: 'MossTalk 商务款翻译机', desc: '标准款全功能 + AI 会议总结', href: '/mosstalk/business', image: '/images/recommendation/mosstalk-business.jpg' },
  ],
  cta: {
    title: '想了解智译一体机的部署方案？',
    desc: '联系我们的方案团队，获取私有化部署建议与报价',
  },
  formUrl: 'https://readdy.ai/api/form/d8fsjqernpmjsc93fdig',
};
